import EventBus from '@/event-bus';
import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
      // Uploading of files
      uploadsQueue: [],
      uploadCount: 0,
    };
  },
  methods: {
    // The follwing method is fired when files are dropped/selected in the input
    uploadFiles(dropped = false) {
      // Define files from file-input
      const files = dropped ? this.dragFiles : this.$refs.buttonUpload.files;

      // Loop over files
      for (let i = 0; i < files.length; i += 1) {
        // For every file call the readFiles method
        this.readFiles(files[i], i);

        this.uploadsQueue[i] = { cd: files[i].name, ct: files[i].type, binary: '' };
      }
    },

    // Method which creates a Filereader instance to handle files (binary)
    readFiles(file, i) {
      // Define new filereader object
      const reader = new FileReader();
      // Add custum value 'index' for right position in uploadsQueue
      reader.index = i;
      // Define readSuccess method
      reader.onload = this.readSuccess;
      // Call readAsBinaryString method which will call readsucess method as a result
      reader.readAsArrayBuffer(file);
    },

    // Method which is called when reader onload succeeds
    readSuccess(evt) {
      // Add binary to currentfile
      this.uploadsQueue[evt.target.index].binary = evt.target.result;
      // Upload file
      this.uploadFileQueue(this.uploadsQueue[evt.target.index]);
    },

    // Method for uploading the file given as a parameter
    async uploadFileQueue(file) {
      try {
        await this.axios.post(this.apiUrl, file.binary, {
          headers: {
            'Content-Disposition': `attachment; filename="${file.cd}"`,
            'Content-Type': file.ct,
          },
        });

        const message = this.transformFileVariable(getString('upload.success'), file.cd);
        this.qNotify(message, 'positive', 'bottom-right', false, `in ${this.apiUrl}`);

        this.uploadCount += 1;

        if (this.uploadCount >= this.uploadsQueue.length) {
          this.uploadCount = 0;
          this.uploadsQueue = [];
        }

        // reset values, get new tree and reset table
        EventBus.$emit('refresh-table');
      } catch (error) {
        this.uploadCount += 1;

        // Only show duplicate message when response is 409
        if (error.response && error.response.status) {
          this.$q.notify({
            timeout: 0,
            closeBtn: true,
            message: this.transformFileVariable(getString('upload.error.type.mime.unsupported'), file.cd),
            detail: (error.response && error.response.status === 409) ? getString('module.library.error.exists.file') : getString('upload.error.type.single'),
            color: 'negative',
            type: 'negative',
            position: 'bottom-right',
            width: '100',
          });
        }

        if (this.uploadCount >= this.uploadsQueue.length) {
          this.uploadCount = 0;
          this.uploadsQueue = [];
        }

        // reset values, get new tree and reset table
        EventBus.$emit('refresh-table');
      }
    },

    transformFileVariable(string, filename) {
      return (string.includes('%file%')) ? string.replace('%file%', filename) : filename;
    },
  },
};
